import type { RevisaoStepProps } from "./types-revisao-step";
import { useRevisaoStep } from "./use-revisao-step";
import { RevisaoStepView } from "./view-revisao-step";

export function RevisaoStep(props: RevisaoStepProps) {
  const vm = useRevisaoStep(props);

  return <RevisaoStepView {...vm} />;
}

export type * from "./types-revisao-step";
